import React from "react";
import "./DataList.css";
import classNames from "classnames";

export const DataList = ({ heading, items, alignment = "" }) => {
  var dataListClass = classNames("data-list", {
    [`data-list--${alignment}`]: alignment,
  });

  return (
    <div className={dataListClass}>
      <div className="data-list__heading">{heading}</div>
      <div className="data-list__list">
        {items.map((item, i) => (
          <dl key={i} className="data-list__row">
            <dt className="data-list__label">{item.label}</dt>
            <dd className="data-list__value">{item.value}</dd>
          </dl>
        ))}
      </div>
    </div>
  );
};
